export const LOCAL_BUSINESS_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  name: "Clear Choice Cleaning Services",
  alternateName: "Clear Choice Janitorial Services",
  description:
    "Professional commercial and residential cleaning and janitorial services in Melbourne, Australia.",
  areaServed: [
    { "@type": "City", name: "Melbourne" },
    { "@type": "State", name: "Victoria" },
    { "@type": "Country", name: "Australia" },
  ],
  telephone: "+61404509680",
  email: "info@clearchoicecs.com.au",
  url: "https://clearchoicecs.com.au",
  image: "https://clearchoicecs.com.au/assets/images/banners/cover.webp",
  address: {
    "@type": "PostalAddress",
    streetAddress: "70 Hughes Crescent",
    addressLocality: "Dandenong North",
    addressRegion: "VIC",
    postalCode: "3175",
    addressCountry: "AU",
  },
  openingHours: "Mo-Sa 09:00-17:00",
};
